// extracted by mini-css-extract-plugin
module.exports = {"sticky":"Leaderboard_sticky__Vk_n2"};